
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Analytics() {
  const [timeRange, setTimeRange] = useState('30days');

  const statsCards = [
    { title: 'Total Revenue', value: '$45,260', change: '+12.5%', trend: 'up', icon: 'ri-money-dollar-circle-line' },
    { title: 'Total Orders', value: '2,847', change: '+8.2%', trend: 'up', icon: 'ri-shopping-cart-line' },
    { title: 'Conversion Rate', value: '3.4%', change: '+0.8%', trend: 'up', icon: 'ri-line-chart-line' },
    { title: 'Avg Order Value', value: '$89.50', change: '-2.1%', trend: 'down', icon: 'ri-receipt-line' }
  ];

  const topProducts = [
    { name: 'Turmeric Face Mask', sales: 234, revenue: '$7,020', growth: '+15%' },
    { name: 'Ashwagandha Capsules', sales: 189, revenue: '$7,560', growth: '+22%' },
    { name: 'Neem Soap Set', sales: 156, revenue: '$3,900', growth: '+8%' },
    { name: 'Herbal Tea Blend', sales: 142, revenue: '$2,698', growth: '+12%' },
    { name: 'Ayurvedic Face Oil', sales: 98, revenue: '$3,920', growth: '+6%' }
  ];

  const customerMetrics = [
    { metric: 'New Customers', value: '456', change: '+18%' },
    { metric: 'Returning Customers', value: '789', change: '+12%' },
    { metric: 'Customer Retention', value: '68%', change: '+4%' },
    { metric: 'Avg Session Duration', value: '4m 32s', change: '+15%' }
  ];

  const trafficSources = [
    { source: 'Organic Search', visitors: '2,543', percentage: '45%', color: 'bg-green-500' },
    { source: 'Social Media', visitors: '1,687', percentage: '30%', color: 'bg-blue-500' },
    { source: 'Direct Traffic', visitors: '845', percentage: '15%', color: 'bg-purple-500' },
    { source: 'Email Marketing', visitors: '422', percentage: '7%', color: 'bg-orange-500' },
    { source: 'Paid Ads', visitors: '169', percentage: '3%', color: 'bg-red-500' }
  ];

  const salesData = [
    { month: 'Jan', sales: 4200, orders: 156 },
    { month: 'Feb', sales: 3800, orders: 142 },
    { month: 'Mar', sales: 5100, orders: 189 },
    { month: 'Apr', sales: 4650, orders: 167 },
    { month: 'May', sales: 5800, orders: 203 },
    { month: 'Jun', sales: 6200, orders: 234 }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <Link to="/admin" className="text-blue-600 hover:text-blue-800">
                <i className="ri-arrow-left-line text-xl"></i>
              </Link>
              <h1 className="text-xl font-semibold text-gray-800">Analytics Dashboard</h1>
            </div>
            <div className="flex items-center space-x-4">
              <select
                value={timeRange}
                onChange={(e) => setTimeRange(e.target.value)}
                className="px-4 py-2 border rounded-lg focus:ring-2 focus:ring-green-500 pr-8"
              >
                <option value="7days">Last 7 days</option>
                <option value="30days">Last 30 days</option>
                <option value="90days">Last 90 days</option>
                <option value="1year">Last year</option>
              </select>
              <button className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 flex items-center space-x-2 whitespace-nowrap">
                <i className="ri-download-line"></i>
                <span>Export Report</span>
              </button>
            </div>
          </div>
        </div>
      </header>

      <div className="p-6 space-y-6">
        {/* Key Metrics */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {statsCards.map((stat, index) => (
            <div key={index} className="bg-white rounded-lg shadow-sm border p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-gray-600">{stat.title}</p>
                  <p className="text-2xl font-bold text-gray-900 mt-1">{stat.value}</p>
                  <div className="flex items-center mt-2">
                    <i className={`${stat.trend === 'up' ? 'ri-arrow-up-line text-green-500' : 'ri-arrow-down-line text-red-500'} text-sm mr-1`}></i>
                    <span className={`text-sm ${stat.trend === 'up' ? 'text-green-600' : 'text-red-600'}`}>
                      {stat.change}
                    </span>
                  </div>
                </div>
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                  <i className={`${stat.icon} text-xl text-green-600`}></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Charts Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Sales Trend */}
          <div className="bg-white rounded-lg shadow-sm border p-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">Sales Trend</h3>
            <div className="h-64 bg-gray-50 rounded-lg flex items-center justify-center mb-4">
              <div className="text-center">
                <i className="ri-line-chart-line text-4xl text-gray-400 mb-2"></i>
                <p className="text-gray-500">Sales trend chart would be displayed here</p>
              </div>
            </div>
            <div className="grid grid-cols-3 gap-4 text-center">
              <div>
                <p className="text-sm text-gray-600">This Month</p>
                <p className="text-lg font-semibold text-gray-900">$6,200</p>
              </div>
              <div>
                <p className="text-sm text-gray-600">Last Month</p>
                <p className="text-lg font-semibold text-gray-900">$5,800</p>
              </div>
              <div>
                <p className="text-sm text-gray-600">Growth</p>
                <p className="text-lg font-semibold text-green-600">+6.9%</p>
              </div>
            </div>
          </div>

          {/* Traffic Sources */}
          <div className="bg-white rounded-lg shadow-sm border p-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">Traffic Sources</h3>
            <div className="space-y-4">
              {trafficSources.map((source, index) => (
                <div key={index} className="flex items-center justify-between">
                  <div className="flex items-center space-x-3">
                    <div className={`w-3 h-3 rounded-full ${source.color}`}></div>
                    <span className="text-sm font-medium text-gray-700">{source.source}</span>
                  </div>
                  <div className="text-right">
                    <p className="text-sm font-medium text-gray-900">{source.visitors}</p>
                    <p className="text-xs text-gray-500">{source.percentage}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Top Products & Customer Metrics */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Top Products */}
          <div className="bg-white rounded-lg shadow-sm border p-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">Top Products</h3>
            <div className="space-y-4">
              {topProducts.map((product, index) => (
                <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                  <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center">
                      <span className="text-xs font-bold text-green-600">{index + 1}</span>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-gray-900">{product.name}</p>
                      <p className="text-xs text-gray-500">{product.sales} sales</p>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="text-sm font-medium text-gray-900">{product.revenue}</p>
                    <p className="text-xs text-green-600">{product.growth}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Customer Metrics */}
          <div className="bg-white rounded-lg shadow-sm border p-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">Customer Metrics</h3>
            <div className="grid grid-cols-2 gap-4">
              {customerMetrics.map((metric, index) => (
                <div key={index} className="p-4 bg-gray-50 rounded-lg">
                  <p className="text-sm text-gray-600">{metric.metric}</p>
                  <p className="text-xl font-bold text-gray-900 mt-1">{metric.value}</p>
                  <p className="text-sm text-green-600 mt-1">{metric.change}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Sales Performance Table */}
        <div className="bg-white rounded-lg shadow-sm border">
          <div className="p-6 border-b">
            <h3 className="text-lg font-semibold text-gray-800">Monthly Sales Performance</h3>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Month</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Sales</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Orders</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Avg Order Value</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Growth</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {salesData.map((data, index) => {
                  const avgOrderValue = (data.sales / data.orders).toFixed(2);
                  const growth = index > 0 ? (((data.sales - salesData[index - 1].sales) / salesData[index - 1].sales) * 100).toFixed(1) : '0';
                  
                  return (
                    <tr key={index}>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{data.month}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">${data.sales.toLocaleString()}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{data.orders}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">${avgOrderValue}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm">
                        <span className={`${parseFloat(growth) >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                          {parseFloat(growth) >= 0 ? '+' : ''}{growth}%
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
